<template>
  <div class="view-remittance-detail-container">
    <b-row>
      <b-col>
        <div>
          <bread-crumbs
            :page="$t('remittances.addRemittance.breadcrumbMain')"
            :section="getBuyerName"
            :pageClick="openListOfRemittance"
          />
          <div class="spacing-32"></div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="8" v-if="remittanceLoading">
        <loader :height="400" />
      </b-col>
      <b-col lg="8" v-else-if="remittanceDetails">
        <!-- Remittance view  -->
        <div class="d-flex justify-content-center remittance-status">
          <page-header
            :title="getBuyerName"
            :sideChipText="
              remittanceDetails && getAccountStatus(remittanceDetails.status)
            "
          />
        </div>
        <div class="spacing-24"></div>
        <remittance-information :remittanceDetails="remittanceDetails" />
        <div class="spacing-24"></div>
      </b-col>
      <b-col lg="4">
        <!-- Widgets -->
        <add-more-widget
          :heading="$t('remittances.listRemittance.cardHeading')"
          :subtitle="$t('remittances.listRemittance.cardDesc')"
          :buttonText="$t('remittances.listRemittance.cardButton')"
          :buttonClick="redirectToRemittance"
          :sideWidget="true"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import BreadCrumbs from '@/components/common/BreadCrumbs'
import remittanceService from '@/services/remittance'
import PageHeader from '@/components/common/PageHeader'
import Loader from '@/components/common/Loader'
import AddMoreWidget from '@/components/common/AddMoreWidget'
import RemittanceInformation from '@/components/remittances/RemittanceInformation'

export default {
  components: {
    BreadCrumbs,
    PageHeader,
    Loader,
    RemittanceInformation,
    AddMoreWidget
  },
  data() {
    return {
      remittanceDetails: null,
      supportingDocuments: [],
      remittanceLoading: false
    }
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    const remittanceId = this.$route.params.rid || this.$route.query.rid
    this.$mpTrack('Add Remittance - View remittance opened', {
      remittance_id: remittanceId
    })
    if (remittanceId) {
      this.fetchRemittance(remittanceId)
    } else {
      console.error(
        'Remittance id not found. Redirecting back to remittance page'
      )
      this.$router.push({ name: 'remittances' })
    }
  },
  methods: {
    redirectToRemittance() {
      this.$mpTrack(this.$t('remittances.listRemittance.eventAdd'))
      this.$router.push({
        name: 'addRemittance',
        params: {}
      })
    },
    getAccountStatus(status) {
      if (status === 'Pending') {
        return this.$t('remittances.listRemittance.listCardStatus.pending')
      }
      if (status === 'Partial Marked') {
        return this.$t('remittances.listRemittance.listCardStatus.partial')
      }
      if (status === 'Marked') {
        return this.$t('remittances.listRemittance.listCardStatus.marked')
      }
      return ''
    },
    openListOfRemittance() {
      this.$mpTrack(`Add Remittance - Navigate to remittance list`)
      this.$router.push({ name: 'remittances' })
    },
    fetchRemittance(rid) {
      this.remittanceLoading = true
      remittanceService
        .fetchRemittanceDetails(rid)
        .then((res) => {
          this.remittanceDetails = res.data
          this.remittanceLoading = false
        })
        .catch((e) => {
          this.remittanceLoading = false
          console.error(e)
        })
    }
  },
  computed: {
    getBuyerName() {
      const company =
        (this.remittanceDetails &&
          this.remittanceDetails.importer_user.company) ||
        ''
      return company.slice(0, 40) + (company.length > 40 ? '...' : '') || ''
    }
  }
}
</script>
<style lang="scss" scoped>
.view-remittance-detail-container {
  padding: 40px 108px;
  @media screen and (max-width: 1025px) {
    padding: 40px 40px;
  }
  @media screen and (max-width: 576px) {
    padding: 24px 16px;
  }
}
</style>
